import type { ImageLoaderProps } from 'next/image';

export default function shopifyImageLoader({
  src,
  width = 300,
}: ImageLoaderProps) {
  return `${src}&width=${width}`;
}
